import { get, post } from '@_shared/config';

import { termsModel } from '../model';

export function getTerms() {
	return get<termsModel.TTerms>('/settings/terms');
}

export function getMarketingTerms() {
	return get('/settings/terms?keyword=TERMS02');
}

export function getPushTerms() {
	return get('/settings/terms?keyword=TERMS01');
}

/**
 * Marketing 정책 동의 정보 전송
 * 전송 시 이전 값의 반대로 변경됨
 */
export function postMarketingTerms() {
	return post('/settings/terms', {
		term: 'TERMS02',
	});
}

/**
 * Marketing 정책 동의 정보 전송
 * 전송 시 이전 값의 반대로 변경됨
 */
export function postPushTerms() {
	return post('/settings/terms', {
		term: 'TERMS01',
	});
}
